
import React from 'react';
import { Button } from '@/components/ui/button';

interface NotFoundViewProps {
  onNavigateBack: () => void;
}

const NotFoundView: React.FC<NotFoundViewProps> = ({ onNavigateBack }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <main className="flex-1 container mx-auto p-3 md:p-6">
        <div className="text-center">
          <h2 className="text-2xl font-bold">Business not found</h2>
          <p className="mt-2 text-muted-foreground">
            The business you're looking for doesn't exist or has been removed.
          </p>
          <Button className="mt-4" onClick={onNavigateBack}>Back to Dashboard</Button>
        </div>
      </main>
    </div>
  );
};

export default NotFoundView;
